import { useEffect, useState } from 'react';
import { FiClipboard, FiPlus } from 'react-icons/fi';
import DashboardLayout from '../../components/layout/DashboardLayout';
import SectionCard from '../../components/ui/SectionCard';
import ListItem from '../../components/ui/ListItem';
import EmptyState from '../../components/ui/EmptyState';
import StatusBadge from '../../components/ui/StatusBadge';
import { getForms } from '../../services/formService';
import { formatDate } from '../../utils/format';

export default function FormsManagementView() {
  const [forms, setForms] = useState(null);

  useEffect(() => {
    let active = true;
    getForms().then((data) => {
      if (active) setForms(data);
    });
    return () => {
      active = false;
    };
  }, []);

  return (
    <DashboardLayout title="Formularios" subtitle={`${forms?.length ?? 0} plantillas`}>
      <button type="button" className="btn btn-outline btn-block" disabled>
        <FiPlus /> Nuevo formulario <span className="badge-soft">Pronto</span>
      </button>

      <SectionCard title="Plantillas">
        {forms === null && <EmptyState icon={<FiClipboard />} title="Cargando formularios…" />}
        {forms?.map((form) => (
          <ListItem
            key={form.id}
            icon={<FiClipboard />}
            title={form.title}
            meta={`${form.category} · ${formatDate(form.createdAt)} · ${form.totalSubmissions} registros`}
            right={<StatusBadge status={form.status} />}
          />
        ))}
      </SectionCard>
    </DashboardLayout>
  );
}
